export default __webpack_public_path__ + "static/char-s-13-cht-957952f91dfefc5b79df9819ba3f80ed.webp";